module.exports = __webpack_public_path__ + "img/SharingRecords02.02ac91d6.svg";